// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 836) return "static/chunks/836-a58ed2cb0f281d1a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"901a2cb9f465e93f","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"bb1df331f5be5ccf","367":"7a45f569a674b9e2","639":"e7b660adfa99260e","748":"31dddbbe7afa009b"}[chunkId] + ".js";
};